/**
 * NHL Sport Configuration (Stub)
 *
 * Basic structure for NHL support. Expand with full team/prop data
 * when NHL launches.
 */

import type { SportConfig } from './types';

export const nhlConfig: SportConfig = {
  sport: 'NHL',
  label: 'NHL Hockey',
  shortLabel: 'NHL',

  oddsApiSportKey: 'icehockey_nhl',

  drawLabel: 'Tie',
  espnPath: { sport: 'hockey', league: 'nhl' },

  positions: [
    { id: 'C', label: 'Center', abbreviation: 'C' },
    { id: 'LW', label: 'Left Wing', abbreviation: 'LW' },
    { id: 'RW', label: 'Right Wing', abbreviation: 'RW' },
    { id: 'D', label: 'Defenseman', abbreviation: 'D' },
    { id: 'G', label: 'Goalie', abbreviation: 'G' },
  ],

  propCategories: [
    { id: 'POINTS', label: 'Goals', oddsApiMarket: 'player_points' },
    { id: 'GOALS', label: 'Goals', oddsApiMarket: 'player_goals' },
    { id: 'ASSISTS', label: 'Assists', oddsApiMarket: 'player_assists' },
    { id: 'SHOTS_ON_GOAL', label: 'Shots on Goal', oddsApiMarket: 'player_shots_on_goal' },
    { id: 'SAVES', label: 'Saves', oddsApiMarket: 'player_saves' },
  ],

  defaultRosterSlots: [
    { slot: 'C', eligiblePositions: ['C'], label: 'Center' },
    { slot: 'LW', eligiblePositions: ['LW'], label: 'Left Wing' },
    { slot: 'RW', eligiblePositions: ['RW'], label: 'Right Wing' },
    { slot: 'D1', eligiblePositions: ['D'], label: 'Defenseman' },
    { slot: 'D2', eligiblePositions: ['D'], label: 'Defenseman' },
    { slot: 'G', eligiblePositions: ['G'], label: 'Goalie' },
    { slot: 'UTIL', eligiblePositions: ['C', 'LW', 'RW', 'D'], label: 'Utility' },
  ],

  defaultRosterSize: 7,
  defaultMaxProps: 5,

  identity: {
    color: '#8E8E8E',
    metal: 'Pewter',
    icon: 'Snowflake',
  },

  teams: {},
};
